import _ from 'lodash';

import { couponsTypes, ratesTypes, shippingTypes } from '../airtable/metadata/settings';
import { submissionCardsFields, submissionFields } from '../airtable/metadata/submissions';
import { unbox } from '../commons/utils';

function computeSubmissionCart(cart, options) {
  cart = {
    ...cart,
    cards: cart.cards.map(card => ({ ...card })),
    // summary: [],
  };
  console.group('Cart');
  console.log('input:', { cart, options });

  cart = applyRates(cart, options.rates);
  cart = applyShipping(cart, options.shipping);
  cart = applyDiscounts(cart, options.coupons);

  cart.discountSummary = sumChildObjects(cart.cards, 'discountSummary');
  cart.discountsTotal = sumSummary(cart.discountSummary);
  cart.ratesSummary = sumChildObjects(cart.cards, 'ratesSummary');
  cart.ratesTotal = sumSummary(cart.ratesSummary);
  cart.shippingTotal = sumSummary(cart.shippingSummary);

  // cart.ratesCount = sumObjectsBy(cart.cards, _.keys(cart.ratesSummary));

  cart.total =
      cart.insuranceTotal
    + cart.ratesTotal
    + cart.shippingTotal;

  const itemsForStripe = Array.from(generateItemsForStripe(cart));

  cart = { ...cart, itemsForStripe };
  console.log('output:', { cart });
  console.groupEnd();

  return cart;
}

function createSubmissionCart(submission, submissionCards) {
  const cards = [];

  for (const submissionCard of submissionCards) {
    const declaredValue = Math.max(0, submissionCard[submissionCardsFields.DECLARED_VALUE]);
    const destination = unbox(submissionCard[submissionCardsFields.DESTINATION]) ?? 'DCI';
    const hardCase = submissionCard[submissionCardsFields.HARD_CASE] === true;
    const quantity = submissionCard.quantity ?? 1;

    const dci = destination === 'DCI';
    const review = dci || submissionCard.dciReview === true;

    const card = {
      dci,
      declaredValue,
      destination,
      hardCase,
      review,
    };

    const copies = Math.max(1, quantity);

    for (let i = 1; i <= copies; i++) {
      cards.push({ ...card });
    }
  }

  return {
    cards,
    couponCode: submission[submissionFields.COUPON_CODE]?.toLowerCase(),
    noReturnShipping: submission[submissionFields.NO_RETURN_SHIPPING] ?? false,
  };
}

function applyRates(cart, rates) {
  const insuranceStepRate = rates.get(ratesTypes.SUBMISSION_INSURANCE_PER_STEP) ?? 0;
  const insuranceStep = rates.get(ratesTypes.SUBMISSION_INSURANCE_STEP) ?? 0;

  const hardCaseRate = rates.get(ratesTypes.SUBMISSION_PER_ITEM_HARD_CASE) ?? 0;
  const reviewRate = rates.get(ratesTypes.SUBMISSION_PER_ITEM_REVIEW) ?? 0;

  for (const card of cart.cards) {
    card.ratesSummary = {
      hardCase: card.hardCase ? hardCaseRate : 0,
      review: card.review ? reviewRate : 0,
    };
    card.ratesTotal = sumSummary(card.ratesSummary);
  }

  const declaredValueTotal = _.sumBy(cart.cards, 'declaredValue');
  const insuranceTotal = Math.floor(declaredValueTotal / insuranceStep) * insuranceStepRate;

  return {
    ...cart,
    declaredValueTotal,
    insuranceStep,
    insuranceStepRate,
    insuranceTotal,
  };
}

function applyShipping(cart, shipping = []) {
  cart.shippingSummary = {};

  shipping = _
    .chain(Array.from(shipping.values()))
    .filter({ enabled: true })
    .groupBy('type')
    .value();

  if (shippingTypes.FLAT in shipping) {
    const entries = shipping[shippingTypes.FLAT];
    const entry = _.maxBy(entries, 'rate');

    cart.shippingSummary[shippingTypes.FLAT] = entry.rate;
  }

  if (shippingTypes.ADDITIONAL_FROM_X_TO_Y_TOTAL_HARD_CASES in shipping) {
    const counter = _.countBy(cart.cards, 'hardCase');
    const count = counter?.true ?? 0;

    const entries = shipping[shippingTypes.ADDITIONAL_FROM_X_TO_Y_TOTAL_HARD_CASES];
    const entry = _
      .chain(entries)
      .filter(({ xValue, yValue }) => {
        return count >= xValue && count <= yValue;
      })
      .maxBy('rate')
      .value();

    cart.shippingSummary[shippingTypes.ADDITIONAL_FROM_X_TO_Y_TOTAL_HARD_CASES] = entry?.rate ?? 0;
  }

  return cart;
}

function applyDiscounts(cart, coupons) {
  for (const card of cart.cards) {
    card.discountSummary = {};
  }

  const coupon = coupons?.get(cart.couponCode);

  if (coupon?.enabled) {

    if (coupon.type === couponsTypes.FREE_RETURN_SHIPPING) {
      cart.shippingSummary = {};
    }

    if (coupon.type === couponsTypes.X_CARDS_FREE
      || coupon.type === couponsTypes.X_CARDS_FREE_WITH_FREE_SHIPPING) {
      const { xValue = 0 } = coupon;

      let x = Math.abs(xValue);

      for (const card of cart.cards) {
        if (x <= 0) {
          break;
        }

        card.discountSummary.review = card.ratesSummary.review;
        card.ratesSummary.review = 0;
        x--;
      }

      if (coupon.type === couponsTypes.X_CARDS_FREE_WITH_FREE_SHIPPING) {
        cart.shippingSummary = {};
      }
    }

    if (coupon.type === couponsTypes.X_CARDS_PAID_GETS_Y_CARDS_FREE) {
      const { xValue, yValue } = coupon;

      let x = Math.abs(xValue);
      let y = Math.abs(yValue);

      for (const card of cart.cards) {
        if (x <= 0 && y <= 0) {
          x = Math.abs(xValue);
          y = Math.abs(yValue);
        }

        if (x > 0) {
          x--;
        } else if (y > 0) {
          card.discountSummary.review = card.ratesSummary.review;
          card.ratesSummary.review = 0;
          y--;
        }
      }
    }

    if (coupon.type === couponsTypes.X_PERCENT_OFF_PER_CARD) {
      const { xValue = 0 } = coupon;

      if (xValue > 0) {
        for (const card of cart.cards) {
          card.discountSummary.review = card.ratesSummary.review * xValue / 100;
          card.ratesSummary.review = card.ratesSummary.review - card.discountSummary.review;
        }
      }
    }

    if (coupon.type === couponsTypes.X_PRICE_PER_CARD) {
      const { xValue = 0 } = coupon;

      for (const card of cart.cards) {
        if (xValue <= 0 || xValue > card.ratesSummary.review) {
          continue;
        }

        card.discountSummary.review = card.ratesSummary.review - xValue;
        card.ratesSummary.review = xValue;
      }
    }

  }

  if (cart.noReturnShipping) {
    cart.shippingSummary = {};
  }

  return cart;
}

export {
  computeSubmissionCart,
  createSubmissionCart,
};

function * generateItemsForStripe(cart) {
  yield* generateDistinctValueItems(cart.cards, 'ratesSummary.review', 'DCI Review');
  yield* generateDistinctValueItems(cart.cards, 'ratesSummary.hardCase', 'Hard case');

  if (cart.shippingTotal > 0) {
    yield generateGenericItem('Shipping (return)', 1, cart.shippingTotal);
  }

  if (cart.insuranceTotal > 0) {
    yield generateGenericItem('Insurance', 1, cart.insuranceTotal);
  }

  function* generateDistinctValueItems(cards, groupBy, name) {
    const groupsByValue = _.groupBy(cards, groupBy);

    for (const [value, group] of Object.entries(groupsByValue)) {
      const title = value > 0 ? name : `${name} (free)`;
      yield generateGenericItem(title, group.length, value);
    }
  }

  function generateGenericItem(name, quantity, amount) {
    return {
      amount: amount * 100, // in cents
      currency: 'usd',
      name,
      quantity,
    };
  }
}

function sumChildObjects(parents, path) {
  const objects = path
    ? _.map(parents, path)
    : parents;

  const keys = _.chain(objects)
    .map(_.keys)
    .flatten()
    .uniq()
    .value();

  return sumObjectsBy(objects, keys);
}

function sumObjectsBy(objects, keys) {
  const values = keys.map(key => {
    const sum = _.sumBy(objects, key);

    if (sum === true) {
      return 1;
    }
    return sum ?? 0;
  });

  return _.zipObject(keys, values);
}

function sumSummary(summary) {
  return _.chain(summary).values().sum().value() ?? 0;
}
